// Copyright (c) 2018 Deere & Company

import ExcelLayout, {getDefaultState as getExcelLayoutDefaultState} from '@deere/cps-it.warranty-model-factory/lib/excel-layout';
import ExcelLayoutModal, {getDefaultState as getExcelLayoutModalDefaultState} from './excel-layout-modal';
import ExcelLayouts, {getDefaultState as getExcelLayoutsDefaultState} from './excel-layouts';
import t from 'tcomb';

const ExportToExcel = t.struct({
    excelLayoutModal: ExcelLayoutModal,
    excelLayouts: t.struct({
        claims: ExcelLayouts,
        partRequests: ExcelLayouts,
        pipProductSearch: ExcelLayouts,
        pipProducts: ExcelLayouts,
        pipSearch: ExcelLayouts,
        productSearch: ExcelLayouts,
        registrations: ExcelLayouts,
        transfers: ExcelLayouts
    }),
    selectedExcelLayout: t.struct({
        claims: ExcelLayout,
        partRequests: ExcelLayout,
        pipProductSearch: ExcelLayout,
        pipProducts: ExcelLayout,
        pipSearch: ExcelLayout,
        productSearch: ExcelLayout,
        registrations: ExcelLayout,
        transfers: ExcelLayout
    })
}, 'ExportToExcel');

export const getDefaultState = () =>
    new ExportToExcel({
        excelLayoutModal: getExcelLayoutModalDefaultState(),
        excelLayouts: {
            claims: getExcelLayoutsDefaultState(),
            partRequests: getExcelLayoutsDefaultState(),
            pipProductSearch: getExcelLayoutsDefaultState(),
            pipProducts: getExcelLayoutsDefaultState(),
            pipSearch: getExcelLayoutsDefaultState(),
            productSearch: getExcelLayoutsDefaultState(),
            registrations: getExcelLayoutsDefaultState(),
            transfers: getExcelLayoutsDefaultState()
        },
        selectedExcelLayout: {
            claims: getExcelLayoutDefaultState(),
            partRequests: getExcelLayoutDefaultState(),
            pipProductSearch: getExcelLayoutDefaultState(),
            pipProducts: getExcelLayoutDefaultState(),
            pipSearch: getExcelLayoutDefaultState(),
            productSearch: getExcelLayoutDefaultState(),
            registrations: getExcelLayoutDefaultState(),
            transfers: getExcelLayoutDefaultState()
        }
    });

export default ExportToExcel;



// WEBPACK FOOTER //
// ./src/shared/state/export-to-excel.js